module.exports = __webpack_public_path__ + "static/media/fondo-home-vuelos.e277cc26.webp";